module.exports = __webpack_public_path__ + "img/l_h8.9e1e9d54.png";